export function initialize(store, router) {
    router.beforeEach((to, from, next) => {
        // closeAllDialogs(store);
        next();
    });
}

// function closeAllDialogs(store) {
//     store.commit("setContactUsDialog", false);
// }